<template>
  <div class="policy-event-summary">
    <span class="lab-tag" :class="color">{{ event.level || '事件' }}</span>
    <h4>{{ event.name }}</h4>
    <dl class="policy-city-measure-fields">
      <dt>状态</dt><dd>{{ status }}</dd>
      <dt>触发条件</dt><dd>{{ event.cond || event.condition || '—' }}</dd>
      <template v-if="event.deadlineRound"><dt>办理时限</dt><dd>第 {{ event.deadlineRound }} 轮前</dd></template>
    </dl>
    <p>{{ event.desc || event.description }}</p>
    <p v-if="event.sourceEventName">前序事件：{{ event.sourceEventName }}</p>
    <p v-if="event.overdue" class="lab-warning">事件已超时</p>
    <p v-if="event.resolution || event.result">处置记录：{{ event.resolution || event.result }}</p>
    <template v-if="event.decisionApplied">
      <p>已选处置方案：{{ event.decisionOptionName }}</p>
      <p>方案评分调整：{{ formatNumber(event.decisionScoreDelta) }} 分</p>
      <details><summary>查看方案产生的指标与资源变化</summary>
        <p v-for="item in event.decisionIndicators || []" :key="item.key">{{ item.name }}：{{ formatNumber(item.before) }} → {{ formatNumber(item.after) }}</p>
        <p>资源总量变化（权威 / 财政 / 周期）：{{ formatNumber((event.decisionResourceChanges || {}).auth) }} / {{ formatNumber((event.decisionResourceChanges || {}).budget) }} / {{ formatNumber((event.decisionResourceChanges || {}).period) }}</p>
      </details>
    </template>
    <p>应对建议：{{ event.advice || '—' }}</p>
  </div>
</template>

<script>
export default {
  name: 'PolicyEventSummary',
  props: {
    event: { type: Object, required: true },
    status: { type: String, required: true },
    color: { type: String, default: 'gray' },
    formatNumber: { type: Function, required: true }
  }
}
</script>
